import script from "./Page17.vue?vue&type=script&setup=true&lang=js"
export * from "./Page17.vue?vue&type=script&setup=true&lang=js"

import "./Page17.vue?vue&type=style&index=0&id=7a09df9c&lang=less"

const __exports__ = script;

export default __exports__